import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { connectionsApi, type AppConnection, type CreateConnectionPayload, type TestResult } from '@/lib/connections-api'

export function useConnections() {
  return useQuery<AppConnection[]>({
    queryKey: ['connections'],
    queryFn: async () => {
      const resp = await connectionsApi.list()
      return resp.data.connections
    },
    staleTime: 0,
  })
}

export function useCreateConnection() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateConnectionPayload) => connectionsApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['connections'] }),
  })
}

export function useDisconnect() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => connectionsApi.disconnect(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['connections'] }),
  })
}

export function useTestConnection() {
  return useMutation<TestResult, Error, number>({
    mutationFn: async (id: number) => {
      const resp = await connectionsApi.test(id)
      return resp.data
    },
  })
}
